// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';
import Analyse from '../../../../../Model/Analyse';
import AnalyseLaborForm from './AnalyseLaborForm';
import AnalyseLabor from '../../../../../Model/AnalyseLabor';

type Props = {
  analyse: Analyse,
};

@observer
export default class LaborTab extends React.Component<Props, void> {
  render() {
    const { analyse: { labor } } = this.props;

    return (
      <Row style={{ paddingTop: 8 }}>
        <Col>
          {labor.map((l: AnalyseLabor, i: number) => (
            <AnalyseLaborForm key={`${i}`} labor={l} index={i} />
          ))}
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/LaborTab/index.js